const LOCAL_STORAGE_PRESERVE_PATTERNS = [
  /^sb-.*-auth-token$/,
  /^vite-ui-theme$/,
  /^i18nextLng$/,
  /^language$/,
];

const SESSION_STORAGE_PRESERVE_PATTERNS = [];
const AUTH_STORAGE_PATTERNS = [/^sb-.*-auth-token$/];

const shouldPreserveKey = (key: string, patterns: RegExp[]) => {
  return patterns.some((pattern) => pattern.test(key));
};

const clearStorage = (storage: Storage, preservePatterns: RegExp[]) => {
  const keysToRemove: string[] = [];

  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (!key || shouldPreserveKey(key, preservePatterns)) {
      continue;
    }

    keysToRemove.push(key);
  }

  keysToRemove.forEach((key) => storage.removeItem(key));
};

export const clearTransientBrowserState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  clearStorage(window.localStorage, LOCAL_STORAGE_PRESERVE_PATTERNS);
  clearStorage(window.sessionStorage, SESSION_STORAGE_PRESERVE_PATTERNS);
};

export const clearBrowserAuthState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  clearStorage(window.localStorage, []);
  clearStorage(window.sessionStorage, []);

  for (const storage of [window.localStorage, window.sessionStorage]) {
    const keysToRemove: string[] = [];

    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key && AUTH_STORAGE_PATTERNS.some((pattern) => pattern.test(key))) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => storage.removeItem(key));
  }
};